import React, { useEffect, useState } from 'react'
import EmptyState from '../../../../components/elements/EmptyState'
import { Link } from 'react-router-dom'
import PlusIcon from '../../../../components/elements/icons/PlusIcon'
import Filters from '../../../../components/elements/Filters'
import ArrowUpTrayIcon from '../../../../components/elements/icons/ArrowUpTrayIcon'
import SearchField from '../../../../components/elements/SearchField'
import ChevronIcon from '../../../../components/elements/icons/ChevronIcon'
import ModalDialog from '../../../../components/layouts/ModalDialog'
import NewInventoryLocation from '../../../../components/partials/inventory/NewInventoryLocation'
import { useDispatch, useSelector } from 'react-redux'
import { clearCreatedInventoryLocation, fetchInventoryLocations } from '../../../../store/actions/inventoryActions'
import Pagination from '../../../../components/elements/Pagination'
import InventoryLocationCard from '../../../../components/partials/inventory/InventoryLocationCard'

const InventoryItems = () => {
    const filterOptions = [
        {
            name: 'date applied',
            linkType: 'option',
            link: ['is after', 'is before'],
            type: 'date',
            value: "",
            displayValue: ""
        }
    ]

    const inventorySelector = useSelector(state =>state.inventory)
    const dispatch = useDispatch()
    const [locationsPage, setLocationsPage] = useState(1)
    const [locationSPerPage, setLocationSPerPage] = useState(25)

    useEffect(() => {
      dispatch(fetchInventoryLocations(``, locationsPage, locationSPerPage))
      if(inventorySelector.createdLocation && inventorySelector.createdLocation !== null) {
        setCreatingLocation(false)
        dispatch(clearCreatedInventoryLocation())
      }
    
      return () => {
      
      }
    }, [dispatch, inventorySelector.createdLocation, locationSPerPage, locationsPage])
    

    const [categoriesOpen, setCategoriesOpen] = useState(false)
    // const [creatingCategory, setCreatingCategory] = useState(false)
    const [creatingLocation, setCreatingLocation] = useState(false)

    const [locationsOpen, setLocationsOpen] = useState(false)
  
    return (
      <>
        <div className='w-full'>
          <div className="w-full mx-auto flex items-center justify-between">
            <div className='w-8/12'>
                <h4 className='font-medium text-lg mb-3 text-gray-400'>Inventory Items</h4>
                <div className='w-2/3'>
                    <p className='text-gray-500 my-3 text-sm'>
                        Set up all inventory items for the college here. You can click on an item to see more details and/or assign them to staff students or departments.
                    </p>
                </div>
            </div>
            <div className='w-4/12 flex flex-row-reverse'>
                <Link to={`new`} className='rounded px-4 py-3 mt-4 text-sm text-purple-100 bg-vcm-purple transition duration-200 border border-vcm-purple hover:bg-vcm-light-purple hover:text-vcm-purple flex items-center justify-center gap-x-2'>
                    <PlusIcon className='w-5 h-5' /> Create new item
                </Link>
            </div>
          </div>

          <div className={`w-full bg-gray-100 p-4 rounded-t-[8px] transition duration-200 border mt-6 ${categoriesOpen ? 'rounded-b-0' : 'rounded-b-[8px]'}`}>
            <div className='cursor-pointer w-full flex items-center justify-between'>
              <div>
                <div className='flex items-center gap-x-3'>
                  <h3 className='font-[500]'>Inventory Locations <span className='text-gray-500 text-[14px]'>({inventorySelector?.locations?.locations?.length} locations)</span></h3>
                  <button onClick={()=>{setCreatingLocation(true)}} className='text-vcm-purple bg-vcm-light-purple bg-opacity-20 p-2 transition text-xs duration-200 hover:text-violet-600 font-medium underline'>Create new location</button>
                </div>
                <p className='text-sm text-gray-500'>Inventory Locations are the different places within the school where items are stored or managed, such as libraries, store rooms, laboratories, kitchens, and offices. Use this section to define and organize where inventory items are kept. Click on "Create new location" above to add a location.</p>
              </div>
              <div className='w-[50px] flex items-center justify-center'>
                <button onClick={()=>{setLocationsOpen(!locationsOpen)}}>
                  <ChevronIcon className={`w-5 h-5 text-gray-500  transition duration-200 ${locationsOpen ? 'rotate-[270deg]' : 'rotate-180'}`} />
                </button>
              </div>
            </div>
            {locationsOpen && <div className='w-full py-[20px]'>
              <div className='w-full'>
                {inventorySelector?.locations?.locations?.length > 0 ? 
                  <>
                      <div className='grid grid-cols-3 gap-[10px]'>
                        {inventorySelector?.locations?.locations?.map((location, locationIndex)=>(<InventoryLocationCard location={location} key={locationIndex} />))}
                      </div>
                      <Pagination
                        pagination={{
                          perPage: locationSPerPage, 
                          currentPage: locationsPage,
                          totalItems: inventorySelector?.locations?.total,
                        }} 
                        changePage={setLocationsPage} 
                        updatePerPage={setLocationSPerPage}
                      />
                  </>
                  :
                    <div className='w-full p-10'>
                      <EmptyState emptyStateText={'No inventory locations created yet. Create some locations to assign inventory items and categories to.'} />
                    </div>
                }
              </div>
            </div>}
          </div>
          
          <div className={`w-full bg-gray-100 p-4 rounded-t-[8px] transition duration-200 border mt-6 ${categoriesOpen ? 'rounded-b-0' : 'rounded-b-[8px]'}`}>
            <div className='cursor-pointer w-full flex items-center justify-between'>
              <div>
                <div className='flex items-center gap-x-3'>
                  <h3 className='font-[500]'>Item Categories</h3>
                  <Link to={`/admin/inventory/item-categories/new`} className='text-vcm-purple bg-vcm-light-purple bg-opacity-20 p-2 transition text-xs duration-200 hover:text-violet-600 font-medium underline'>Create new category</Link>
                </div>
                <p onClick={()=>{setCategoriesOpen(!categoriesOpen)}} className='text-sm text-gray-500'>Inventory Item Categories are used to classify inventory items into logical groups for structured management, reporting, and control. Categorizing items improves visibility, simplifies tracking, and supports accurate inventory oversight across the school. Create a new category by clicking on "Create new category" above</p>
              </div>
              <div className='w-[50px] flex items-center justify-center'>
                <button onClick={()=>{setCategoriesOpen(!categoriesOpen)}}>
                  <ChevronIcon className={`w-5 h-5 text-gray-500  transition duration-200 ${categoriesOpen ? 'rotate-[270deg]' : 'rotate-180'}`} />
                </button>
              </div>
            </div>
            {categoriesOpen && <div className='w-full'></div>}
          </div>

          <div className='w-full flex items-center justify-between my-5 p-2 rounded-md border'>
            <div className='w-6/12'>
              <Filters filterOptions={filterOptions} />
            </div>
            <div className='w-6/12 flex flex-row-reverse gap-x-2'>
              <button onClick={()=>{}} className={`text-gray-700 px-3 py-2 hover:bg-gray-100 transition duration-200 text-sm flex items-center justify-center gap-x-2 bg-gray-200 rounded border`}>
                <ArrowUpTrayIcon className={`w-5 h-5`} />
                Export Items
              </button>
              <div className='w-[350px]'>
                <SearchField 
                  placeholderText={`Search for inventory item`}
                  showResultsDropDown={false}
                  triggerSearch={(term)=>{}}
                  // performingSearch={invoicesSelector.loadingInvoices}
                />
              </div>
            
            </div>
          </div>

          {/* {staffSelector?.loadingStaff ? 
            <Loader />
            : */}
            <>
              {/* {staffSelector?.staffMembers?.staff?.length > 0 ? 
                <div className=''>
                  {view === 'grid' && 
                    <>
                      <div className='mt-8 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 2xl:grid-cols-4 gap-8'>
                        {staffSelector?.staffMembers?.staff?.map((student, studentIndex)=>(
                          <div key={studentIndex}>
                            <StudentCard student={student} />
                          </div>
                        ))}
                      </div>
                      <Pagination 
                        pagination={{
                          perPage, 
                          page,
                          totalItems: staffSelector?.staffMembers?.total,
                        }} 
                        changePage={setPage} 
                        updatePerPage={setPerPage}
                      />
                    </>
                  }
                  {view === 'list' && <div className='w-full'>
                    <DataTable
                      tableHeaders={tableHeadersFields(cleanUpTableData(staffSelector.staffMembers.staff)[0]).headers} 
                      tableData={cleanUpTableData(staffSelector.staffMembers?.staff)} 
                      columnWidths={columnWidths}
                      columnDataStyles={columnDataStyles}
                      allFields={tableHeadersFields(cleanUpTableData(staffSelector.staffMembers?.staff)[0]).fields}
                      onSelectItems={()=>{}}
                      tableOptions={tableOptions}
                      pagination={{
                          perPage, 
                          page,
                          totalItems: staffSelector.staffMembers.total,
                      }}
                      onSelectSingle={()=>{}}
                      changePage={setPage}
                      updatePerPage={setPerPage}
                    />
                  </div>
                  }
                </div>
                :  */}
                <div className='mt-24 w-1/2 mx-auto'>
                  <EmptyState emptyStateText={`No inventory items have been created yet! You can create new items by clicking on "Create new item" above`} />
                </div>

              {/* } */}
            </>
          {/* } */}
        </div>

        <ModalDialog
          shown={creatingLocation} 
          closeFunction={()=>{setCreatingLocation(false)}} 
          actionFunction={()=>{}} 
          actionFunctionLabel={``}
          dialogTitle='Create a new Inventory Location'
          maxWidthClass='max-w-lg'
          hideActions={true}
        >
            <NewInventoryLocation 
              // reload={()=>setReload(reload+1)}
              close={()=>{setCreatingLocation(false)}} 
            />

        </ModalDialog>
      </>
    )
}

export default InventoryItems